import axios from 'axios';
import { message } from 'antd';
import apiUrl from 'helpers/apiUrl';

const getExpertArticlesGarden = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-articles`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getExpertArticleGardenById = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-articles/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeExpertArticleGardenById = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/garden-articles/${idNews}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const createExpertArticleGarden = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/garden-articles`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danym tytule już istnieje');
      } else {
        message.success('Pozytywnie utworzono poradę GARDEN');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const deleteExpertArticlesGardenCache = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/garden-articles/cache`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveExpertArticleGarden = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/garden-articles/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken
            }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export {
  saveExpertArticleGarden,
  getExpertArticleGardenById,
  getExpertArticlesGarden,
  removeExpertArticleGardenById,
  createExpertArticleGarden,
  deleteExpertArticlesGardenCache,
};
